import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeExternal from "../external/pages/HomeExternal";
import ConfirmacionVisita from "../external/pages/ConfirmacionVisita";
import CancelacionVisita from "../external/pages/CancelacionVisita";


const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
<Route path="/" element={<HomeExternal />} />
<Route path="/external/:refVisita?" element={<HomeExternal />} />
<Route path="/external/confirmar/:refVisita?" element={<ConfirmacionVisita />} />
<Route path="/external/cancelar/:refVisita?" element={<CancelacionVisita />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;